/**
 ------------------------------------------------------------------------------
 Section: Product Recommendations
 - Uses 'PDPs'
 - Logic: Fetches product recommendations from a URL and displays them
 ------------------------------------------------------------------------------
 */

class ProductRecommendations extends HTMLElement {
    constructor() {
        super();

        // Fetch recommendations when the element is in view
        const handleIntersection = async (entries, observer) => {
            console.log('entries', entries);
            if (!entries[0].isIntersecting) {
                console.log('not intersecting');
                return;
            }
            observer.unobserve(this);

            fetch(this.dataset.url)
                .then(response => response.text())
                .then(text => {
                    const html = document.createElement('div');
                    html.innerHTML = text;
                    const recommendations = html.querySelector('product-recommendations');
                    if (recommendations && recommendations.innerHTML.trim().length) {
                        this.innerHTML = recommendations.innerHTML;
                    }

                    console.log('recommendations', recommendations);

                    const linksTo = document.querySelectorAll('.link-to');
                    linksTo.forEach(linked => {
                        linked.addEventListener('click', () => {
                            window.location.href = linked.closest('.card').querySelector('.href');
                        });
                    });
                })
                .catch(e => {
                    console.error(e);
                });
        }


        // Observe the element
        new IntersectionObserver(handleIntersection.bind(this), {
            rootMargin: '0px 0px 200px 0px'
        }).observe(this);
    }
}

customElements.define('product-recommendations', ProductRecommendations);